import React from 'react';

import { Text } from '~/components/Text';

export function StatusVenda(props) {
	const { status } = props;

	switch (typeof status === typeof 'string' ? status.toLowerCase() : status) {
		case 1:
			return <Text color="green">Confirmado</Text>;
		case 'cancelada':
		case 'cancelado':
			return <Text color="red">Cancelado(a)</Text>;
		case 'pendente':
			return <Text color="yellow">Pendente</Text>;
		case 'confirmado':
		case 'confirmada':
			return <Text color="green">Confirmado</Text>;
		case 'pago':
			return <Text color="green">Pago</Text>;
		case 'processando':
			return <Text color="orange">Processando</Text>;
		case 'gerado':
		case 'gerada':
			return <Text color="blue">Gerado(a)</Text>;
		case 'agendado':
		case 'agendada':
			return <Text color="grayDark">Agendado</Text>;
		default:
			return <Text>{status}</Text>;
	}
}
